/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { injectable } from "tsyringe";

import { OnlyDev } from "src/shared/decorators/only-dev";

enum Styles {
    NORMAL = "font-weight: bold; color: #444444",
    INFO = "font-weight: bold; color: #0099cc;",
    SUCCESS = "font-weight: bold; color: #00af3f;",
    WARNING = "font-weight: bold; color: #f39c12;",
    ERROR = "font-weight: bold; color: #ff0048;",
}

@injectable()
export class Logger {
    @OnlyDev()
    normal(message?: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.NORMAL, ...args);
        } else {
            console.log(`%c${message}`, Styles.NORMAL);
        }
    }

    @OnlyDev()
    info(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.INFO, ...args);
        } else {
            console.log(`%c${message}`, Styles.INFO);
        }
    }

    @OnlyDev()
    success(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.SUCCESS, ...args);
        } else {
            console.log(`%c${message}`, Styles.SUCCESS);
        }
    }

    @OnlyDev()
    warn(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.WARNING, ...args);
        } else {
            console.log(`%c${message}`, Styles.WARNING);
        }
    }

    @OnlyDev()
    error(message: any, ...args: any[]) {
        if (args) {
            console.log(`%c${message}`, Styles.ERROR, ...args);
        } else {
            console.log(`%c${message}`, Styles.ERROR);
        }
    }

    @OnlyDev()
    showTable(data: Record<string, any>) {
        console.table(data);
    }

    @OnlyDev()
    time(message: any) {
        console.time(`%c${message}`);
    }

    @OnlyDev()
    timeEnd(message: any) {
        console.timeEnd(`%c${message}`);
    }
}
